var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonewhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3041 12.3102C16.1787 13.2629 15.7108 14.1375 14.9878 14.7705C14.2647 15.4034 13.336 15.7516 12.375 15.7499C6.79219 15.7499 2.25001 11.2077 2.25001 5.62486C2.24828 4.66389 2.59643 3.73515 3.22941 3.01211C3.8624 2.28907 4.73694 1.82117 5.68969 1.6958C5.93062 1.66638 6.1746 1.71567 6.38522 1.83631C6.59583 1.95695 6.76178 2.14247 6.85829 2.36517L8.34329 5.6804V5.68884C8.41718 5.85932 8.44769 6.04544 8.43211 6.23058C8.41653 6.41573 8.35533 6.59413 8.25399 6.74986C8.24133 6.76884 8.22797 6.78642 8.21391 6.804L6.75001 8.53931C7.27665 9.60947 8.39602 10.719 9.48024 11.247L11.1916 9.79087C11.2085 9.77675 11.2261 9.7636 11.2444 9.7515C11.4 9.64772 11.579 9.58437 11.7652 9.56718C11.9515 9.55 12.1391 9.57951 12.311 9.65306L12.3202 9.65728L15.6326 11.1416C15.8557 11.2377 16.0417 11.4035 16.1627 11.6142C16.2837 11.8248 16.3333 12.069 16.3041 12.3102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonewhite);
export default __webpack_public_path__ + "static/media/phonewhite.7000a3e2a9660e9690fa1e74df1f4ba8.svg";
export { ForwardRef as ReactComponent };